module.exports = __webpack_public_path__ + "img/analysis_faq_noreply.4013fa1b.svg";